import * as React from "react";
import {Component, Fragment} from "react";

import {connect} from "react-redux";
import {IRootState} from "../../../store";
import DispatchProps from "../../../utils/DispatchProps";
import ApiService from "../../ApiService";
import Actions from "../../../redux/Actions";

import H from "history";
import OnboardTimeline, {OnboardTimelineItem} from "./OnboardTimeline";
import OnboardHelpBox from "./OnboardHelpBox";
import {MegaMenuOption, MegaMenuOptions} from "../../MegaMenuItemSelector";
import MegaMenuCard from "./MegaMenuCard";
import School from "../../../models/School";
import OnboardNavigation from "./OnboardNavigation";
import * as _ from "lodash";
import {MessageBarType} from "office-ui-fabric-react";
import LoadingPage from "../../LoadingPage";


interface OnboardMegaMenuPageProps {
    tenantId: string;
    schoolCode: string;
    

    apiService: ApiService;
    history: H.History;
}

interface OnboardMegaMenuPageState {
    loading: boolean;
    originalMegaMenuOptions?: MegaMenuOptions;
    updatedMegaMenuOptions?: MegaMenuOptions;
}

class OnboardMegaMenuPage extends Component<OnboardMegaMenuPageProps & DispatchProps,OnboardMegaMenuPageState> {

    constructor(props: OnboardMegaMenuPageProps & DispatchProps) {
        super(props);

        this.state = {
            loading: false,
            originalMegaMenuOptions: undefined,
            updatedMegaMenuOptions: undefined
        };
    }

    async componentDidMount(): Promise<void> {
        if (this.props.tenantId)
        {        
            await this.load();
        }
    }

    async componentDidUpdate(prevProps: Readonly<OnboardMegaMenuPageProps & DispatchProps>, prevState: OnboardMegaMenuPageState): Promise<void> {

        if (this.props.tenantId !== prevProps.tenantId || this.props.schoolCode !== prevProps.schoolCode)
        {
            await this.load();
        }
        
        if(this.state.originalMegaMenuOptions !== prevState.originalMegaMenuOptions)
        {
            this.setState({
               updatedMegaMenuOptions: _.cloneDeep(this.state.originalMegaMenuOptions) 
            });
        }
    }

    private async load(): Promise<void> {
        
        this.setState({
            loading: true
        });
        
        const originalMegaMenuOptions = await this.props.apiService.getMegaMenuOptions(this.props.tenantId,this.props.schoolCode);
        this.setState({
            originalMegaMenuOptions,
            loading: false
        })        
    }

    private save = async (): Promise<boolean> => {

        if(!this.state.updatedMegaMenuOptions)
        {
            return false;
        }
        
        ["one","two","three","four"].forEach((key) => {
            const updatedOption: MegaMenuOption | null = this.state.updatedMegaMenuOptions![key];
            if(_.trim(updatedOption?.listName) === "")
            {
                this.state.updatedMegaMenuOptions![key] = null;
            }
        })
        
        try
        {
            await this.props.apiService.putMegaMenuOptions(this.props.tenantId, this.props.schoolCode, this.state.updatedMegaMenuOptions);
            
            this.props.dispatch(Actions.showMessageBar(`Saved MegaMenu options`,MessageBarType.success));
            
            return true;
        }
        catch(e)
        {
            this.props.dispatch(Actions.showMessageBar(`Failed to save MegaMenu options : ${e.message}`,MessageBarType.error));
            return false;
        }
        
        
    }     

    private onMegaMenuOptionsChanged = (updatedOptions: MegaMenuOptions): void =>
    {
        this.setState({
            updatedMegaMenuOptions: updatedOptions
        });
    }

    public render(): JSX.Element {
        if (this.state.loading) {
            return <LoadingPage />;
        }

        return (
            <Fragment>
                <OnboardHelpBox currentTimelineItemKey={"mega-menu"}/>
                <OnboardTimeline tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} apiService={this.props.apiService}>
                    {(school: School,timelineItems: OnboardTimelineItem[]) => {
                        return (
                            <Fragment>
                                <div className={"flex-item--flex-1"}>
                                    <MegaMenuCard megaMenuOptions={this.state.updatedMegaMenuOptions!} onMegaMenuOptionsChanged={this.onMegaMenuOptionsChanged} school={school}/>
                                </div>
                                <OnboardNavigation currentTimelineItemKey={"mega-menu"} timelineItems={timelineItems} completeItem={this.save} enableNext={true} enableSave={false} history={this.props.history} tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} />
                            </Fragment>
                        );
                    }}
                </OnboardTimeline>

            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState, ownProps: any): OnboardMegaMenuPageProps => {
        return {
            tenantId: ownProps.match.params.tenantId,
            schoolCode: ownProps.match.params.schoolCode,

            apiService: state.auth.apiService,
            history: ownProps.history
        };
    }
)(OnboardMegaMenuPage)